import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SiteFooter } from "@/components/SiteFooter";

const SECTIONS = [
  ["About these terms", [
    "These terms apply to your use of Strategic Ratings, a service of Strategic Racing (ABN 52 047 318 854), Unit 24806, Tower 2, 16 Casino Drive, Broadbeach Qld 4218.",
    "By creating an account or using the service you agree to these terms. You must be 18 years or older to use Strategic Ratings.",
  ]],
  ["Free trial and subscriptions", [
    "Every new account gets a 7-day free trial with no card needed. One free trial is allowed per person.",
    "After the trial, access is by pass (7 days, 1 month, 3 months, 6 months or 12 months). Each pass is a one-off payment in Australian dollars and does not auto-renew.",
    "Buying another pass adds its time on top of any access you already have. Prices are shown on the Subscription page and may change for future purchases.",
    "Payments are processed securely by Stripe. Promo codes are applied at checkout and cannot be exchanged for cash.",
  ]],
  ["Refunds", [
    "Passes give immediate access to digital content, so they are generally non-refundable once access has started.",
    "Nothing in these terms limits your rights under the Australian Consumer Law. If the service is faulty or not as described, contact us and we will work with you on a remedy, which may include a refund or extra access time.",
    "Deleting your account does not refund any remaining pass time.",
  ]],
  ["Not betting advice", [
    "Ratings, prices, selections and Preferred Races are an informational guide only, based on our analysis of publicly available form. They are not financial or betting advice, and no result is guaranteed.",
    "Racing data comes from third-party feeds and can contain errors, late scratchings or changes. Always check the official fields and odds before placing any bet.",
    "Any bet you place is your own decision and at your own risk. Strategic Racing is not a bookmaker and does not accept bets.",
    "Please gamble responsibly. For free and confidential support call the National Gambling Helpline on 1800 858 858 or visit gamblinghelponline.org.au.",
  ]],
  ["Your account", [
    "Keep your login details private. Accounts are for personal use and must not be shared, resold or used to copy or republish our ratings.",
    "We may suspend or close accounts that break these terms or misuse the service.",
    "You can delete your account at any time from the Subscription page.",
  ]],
  ["Liability", [
    "To the extent permitted by law, Strategic Racing is not liable for any loss, including betting losses, arising from your use of the service or reliance on its ratings and prices.",
    "We aim to keep the service available but do not guarantee it will be uninterrupted or error-free.",
  ]],
  ["Privacy and contact", [
    "How we handle your personal information is explained in our privacy summary on the Contact & Support page. Your personal data is never sold or shared with a third party.",
    "These terms are governed by the laws of Queensland, Australia. Questions? Contact us on 0431 121 020 or admin@strategic-racing.com.au.",
  ]],
];

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#060A12] text-slate-200" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-6 pt-10 pb-4 space-y-10">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-white transition-colors" data-testid="terms-home-link"><ArrowLeft className="h-4 w-4" />Strategic Ratings</Link>
        <div>
          <div className="eyebrow text-emerald-400 mb-2">Terms &amp; Conditions</div>
          <h1 className="text-4xl sm:text-5xl font-bold text-white" data-testid="terms-title">Terms of Use</h1>
          <p className="text-slate-400 mt-3 text-sm">Last updated October 2026</p>
        </div>
        {SECTIONS.map(([title, items], i) => (
          <section key={title} className="space-y-3" data-testid={`terms-section-${i}`}>
            <h2 className="font-display text-xl font-bold text-white">{i + 1}. {title}</h2>
            <ul className="space-y-2 text-sm text-slate-300 leading-relaxed">
              {items.map((t) => <li key={t} className="flex gap-2"><span className="text-emerald-400">•</span><span>{t}</span></li>)}
            </ul>
          </section>
        ))}
      </div>
      <SiteFooter />
    </div>
  );
}
